module.exports = __webpack_public_path__ + "img/live-bg.e0e4de8f.png";